import { render, staticRenderFns } from "./UpdateConfirm.vue?vue&type=template&id=0b0e82a0"
import script from "./UpdateConfirm.vue?vue&type=script&lang=ts"
export * from "./UpdateConfirm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports